import gql from 'graphql-tag';

import { PubBoxDetails } from '../../../../../graphql/fragments/pub_box';

export const BulkVote = gql`
  mutation bulkVote($input: FaceMatchBulkCollectionInputType!) {
    bulkVote(input: $input) {
      success
    }
  }
`;

export const HumanLabeledPubBoxVote = gql`
  mutation humanLabeledPubBoxVote($input: HumanLabeledPubBoxVoteInput!) {
    humanLabeledPubBoxVote(input: $input) {
      success
    }
  }
`;

export const IdentityPubBoxCreate = gql`
  mutation identityPubBoxCreate($input: IdentityPubBoxCreateInput!) {
    identityPubBoxCreate(input: $input) {
      pub_box {
        ...PubBoxDetails
      }
    }
  }
  ${PubBoxDetails}
`;
